import { type AccordianItem } from 'components/Accordian';

import useAccordianItemRender from './useAccordianItemRender';

export interface AccordianItemRenderProps {
  item: AccordianItem;
}

const AccordianItemRender: React.FunctionComponent<AccordianItemRenderProps> =
  function ({ item }) {
    const { collapseRef, handleClick, className, contentStyle } =
      useAccordianItemRender(item);
    return (
      <div className={className}>
        <button type="button" onClick={handleClick}>
          {item.button}
        </button>
        <div style={contentStyle} className="overflow-hidden">
          <div ref={collapseRef}>{item.content}</div>
        </div>
      </div>
    );
  };

export default AccordianItemRender;
